module.exports = __webpack_public_path__ + "img/small-logo.d2f844f1.svg";